<script lang="ts" setup>
  import { StoreLayout, AccountLayout } from '@storefront/components';
  import type { Paginator } from '@othercommerce/domain';
  import type { ListOrderItemResource, OrderResource } from '@storefront/resources';

  interface Props {
    products: Paginator<ListOrderItemResource>;
    order?: OrderResource;
    complaint: string;
    back: string;
  }

  defineOptions({
    layout: [StoreLayout, AccountLayout],
    inheritAttrs: false,
  });

  defineProps<Props>();

</script>
<template>
  <AccountMobileNavigation :href="$route('web.account.show')">
    {{ $t('SHOP.ACCOUNT.HEADER.COMPLAINT_CHOOSE_PRODUCTS') }}
  </AccountMobileNavigation>
  <ComplaintProductsView v-bind="$props" />

  <RouterView />
</template>